/* eslint-disable */
/// This file is auto generated - do not edit manually
export const AdvisorOverviewTitle = 'Website.Advisor.AdvisorOverviewTitle';
export const ReadProfile = 'Website.Advisor.ReadProfile';
export const QATitle = 'Website.Advisor.QATitle';
export const FeedTitle = 'Website.Advisor.FeedTitle';
export const FavoritesTitle = 'Website.Advisor.FavoritesTitle';
